import { ArrowRightIcon } from '@heroicons/react/20/solid'
import { useNavigate } from 'react-router'

import { Button } from '@ui/components/core'

export const AvailabilitySuccess = ({ onTryDemo }: { onTryDemo: () => void }) => {
  const navigate = useNavigate()

  return (
    <div className="flex h-screen flex-col items-center justify-center space-y-4 border-2 border-gray-200 p-4">
      <div className="flex max-w-[40rem] flex-col items-start justify-center space-y-4">
        <div className="flex w-full flex-col items-center justify-center space-y-4">
          <h1 className="text-4xl font-semibold text-secondary-800">
            Get ready to start using <span className="font-bold text-primary-500">Datable</span>!
          </h1>
          <p className="text-base font-normal text-gray-600">How it works</p>
        </div>
        <div className="flex">
          <div className="w-8">
            <p className="text-md text-secondary-800">1</p>
          </div>
          <div className="flex-1 space-y-2">
            <p className="text-lg font-semibold text-secondary-800">Configure your source</p>
            <p className="text-base font-normal text-gray-600">
              Select your data source and follow configuration instructions. Don&apos;t worry you can add more later!
            </p>
          </div>
        </div>
        <div className="flex">
          <div className="w-8">
            <p className="text-md text-secondary-800">2</p>
          </div>
          <div className="flex-1 space-y-2">
            <p className="text-lg font-semibold text-secondary-800">Start Transforming Data</p>
            <p className="text-base font-normal text-gray-600">
              Now that your data source is connected, it&apos;s time to start transforming your data using our pipeline!
            </p>
          </div>
        </div>
      </div>

      <Button
        onClick={() => navigate('/onboarding')}
        className="max-w-[10rem] transition-all duration-300 ease-in-out"
        icon={<ArrowRightIcon className="h-4 w-4" />}
        iconPosition="right">
        <p>Next</p>
      </Button>

      <p
        onClick={() => onTryDemo()}
        className="cursor-pointer text-base font-medium text-gray-600 underline transition-all duration-300 ease-in-out hover:text-primary-500">
        Skip setup and go to Sandbox
      </p>
    </div>
  )
}
